import styled from 'styled-components';
import { checkPixel } from 'utils';
import { ColDiv } from 'styles';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => checkPixel($gap) || '48px'};
`;

export const Circle = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme, $color }) => theme.colors[$color] || theme.colors.primary};

  @media ${({ theme }) => theme.device.mobile} {
    width: 4px;
    min-width: 4px;
    height: 4px;
    margin-top: 6.5px;
  }
`;

export const TextBox = styled(ColDiv)`
  color: ${({ theme }) => theme.colors.darkest};
`;

export const H4 = styled.h4`
  font-size: 2.375rem;
  line-height: 1.2;

  span {
    font-size: 2.375rem;
    font-weight: 400;
  }

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 1.5rem;
    span {
      font-size: 1.5rem;
    }
  }
`;

export const ImgBox = styled.div`
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  border-radius: 16px 0 16px 0;
  overflow: hidden;
  max-width: 480px;
  width: 100%;
  height: 390px;

  @media ${({ theme }) => theme.device.tablet} {
    max-width: 100%;
  }
`;

export const AddressBox = styled.div`
  background-color: ${({ theme }) => theme.colors.fill02};
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 24px;

  @media ${({ theme }) => theme.device.tablet} {
    gap: 16px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    gap: 8px;
    align-items: flex-start;
  }
`;

export const MapLinkBox = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;

  @media ${({ theme }) => theme.device.mobile} {
    gap: 8px;
  }
`;

export const MapLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-decoration: none;
  transition: transform 0.2s, opacity 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 36px;
    height: 36px;
  }

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const KakaoMapIcon = styled.svg`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FEE500;
  padding: 8px;
  box-sizing: border-box;

  @media ${({ theme }) => theme.device.mobile} {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
`;

export const NaverMapIcon = styled.svg`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #03C75A;
  padding: 8px;
  box-sizing: border-box;

  @media ${({ theme }) => theme.device.mobile} {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
`;

export const CertificationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-top: 24px;
  }
`;

export const CertificationItem = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  background-color: ${({ theme }) => theme.colors.white};

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  row-gap: 32px;

  @media ${({ theme }) => theme.device.tablet} {
    gap: 16px;
    row-gap: 24px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: 1fr;
    gap: 16px;
    row-gap: 16px;
  }
`;
